import { RouterProvider } from 'react-router-dom';
import { Toaster } from 'react-hot-toast'; // ✅ Import Toaster

// project import
import router from 'routes';
import ThemeCustomization from 'themes';

import Locales from 'components/Locales';
// import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

// auth-provider
import { JWTProvider as AuthProvider } from 'contexts/JWTContext';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import AlertLogoutPopup from 'components/AlertLogoutPopup';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <ThemeCustomization>
      {/* <RTLLayout> */}
      <Locales>
        <ScrollTop>
          <AuthProvider>
            <>
              <Notistack>
                <RouterProvider router={router} />
                <Snackbar />
              </Notistack>

              {/* ✅ Add Toaster component here for global toasts */}
              <Toaster position="top-center" reverseOrder={false} />
            </>
            <AlertLogoutPopup />
          </AuthProvider>
        </ScrollTop>
      </Locales>
      {/* </RTLLayout> */}
    </ThemeCustomization>
  </QueryClientProvider>
);

export default App;
